import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import './index.css';
import { useParams, useHistory } from "react-router-dom";
import { format } from 'date-fns-tz'
import api from '../../services/api_adiantamento';
import styles from './styles.module.css';

export default function Adiantamento() {

    const [adiantamentos, setAdiantamentos] = useState([]);
    const [nextPay, setNextPay] = useState([]);
    const [buscando, setBuscando] = useState(false);
    const [empresa, setEmpresa] = useState({
        items: [
            { id: 0, text: "TODOS" },
        ],
        selectItem: 0
    });
    const [status, setStatus] = useState({
        items: [
            { id: 6, text: "TODOS" },
            { id: 0, text: "AGUARDANDO" },
            { id: 1, text: "APROVADO" },
            { id: 2, text: "PARCIALMENTE PAGO" },
            { id: 3, text: "REJEITADO" },
            { id: 4, text: "PAGO" },
            { id: 5, text: "CONCLUIDO" },
        ],
        selectItem: 6
    });
    const [pedido, setPedido] = useState('');
    const [fornecedor, setFornecedor] = useState('');
    const [dtIni, setDtIni] = useState('');
    const [dtFin, setDtFin] = useState('');
    const [usuario, setUsuario] = useState(null);
    const [logEmpresa, setLogEmpresa] = useState({});
    const [page, setpage] = useState({});
    const [pageClicked, setPageClicked] = useState(1);
    const [filter, setFilter] = useState(false);

    let history = useHistory();

    let params = useParams();

    useEffect(() => {
        api.get(`/empresa/find`).then(function (response) {
            if (response.data) {
                setLogEmpresa(response.data);
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });
    }, [])

    useEffect(() => {
        if (usuario) {
            handleFilter();
        }
    }, [usuario]);

    function onSubmit(event) {
        event.preventDefault();
        history.push('/novoadiantamento');
    }

    function clickTable(event) {
        event.preventDefault();

        let adiantamento = adiantamentos.find(adiantamento => adiantamento.id == event.target.id);
        if (adiantamento.status == 0 && adiantamento.usuario_id == usuario.id && logEmpresa.id == adiantamento.empresa_id) {
            history.push('/novoadiantamento/' + adiantamento.id);
        } else {
            history.push('/gestaoadiantamento/' + adiantamento.id);
        }
    }

    function rowAdiantamento(adiantamento) {
        var isFinanceiro = false;
        if (usuario?.perfis) {
            usuario.perfis.forEach((perfil) => {
                if (perfil.descricao == 'FINANCEIRO') {
                    isFinanceiro = true;
                }
            })
        }

        switch (adiantamento.status) {
            case 1:
                return (
                    <tr className="table-success mouse" onClick={clickTable} id={adiantamento.id} key={adiantamento.id}>
                        <td id={adiantamento.id}>{adiantamento.empresa.descempresa}</td>
                        <td id={adiantamento.id}>{adiantamento.solicitante}</td>
                        <td id={adiantamento.id}>{adiantamento.num_documento}</td>
                        <td id={adiantamento.id}>{adiantamento.fornecedor.descricao}</td>
                        <td id={adiantamento.id}>{format(new Date(adiantamento.data), 'dd/MM/yyyy', { timeZone: 'America/Sao_Paulo' })}</td>
                        <td id={adiantamento.id}>{format(new Date(adiantamento.previsao_encerramento), 'dd/MM/yyyy', { timeZone: 'America/Sao_Paulo' })}</td>
                        <td id={adiantamento.id}>{adiantamento.vlr_total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                        <td id={adiantamento.id}>{adiantamento.saldo.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                        <td id={adiantamento.id}>APROVADO</td>
                    </tr>
                );
            case 2:
                return (
                    <tr className="table-secondary mouse" onClick={clickTable} id={adiantamento.id} key={adiantamento.id}>
                        <td id={adiantamento.id}>{adiantamento.empresa.descempresa}</td>
                        <td id={adiantamento.id}>{adiantamento.solicitante}</td>
                        <td id={adiantamento.id}>{adiantamento.num_documento}</td>
                        <td id={adiantamento.id}>{adiantamento.fornecedor.descricao}</td>
                        <td id={adiantamento.id}>{format(new Date(adiantamento.data), 'dd/MM/yyyy', { timeZone: 'America/Sao_Paulo' })}</td>
                        <td id={adiantamento.id}>{format(new Date(adiantamento.previsao_encerramento), 'dd/MM/yyyy', { timeZone: 'America/Sao_Paulo' })}</td>
                        <td id={adiantamento.id}>{adiantamento.vlr_total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                        <td id={adiantamento.id}>{adiantamento.saldo.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                        <td id={adiantamento.id}>PARCIALMENTE PAGO</td>
                    </tr>
                );
            case 3:
                if (!isFinanceiro) {
                    return (
                        <tr className="table-danger mouse" onClick={clickTable} id={adiantamento.id} key={adiantamento.id}>
                            <td id={adiantamento.id}>{adiantamento.empresa.descempresa}</td>
                            <td id={adiantamento.id}>{adiantamento.solicitante}</td>
                            <td id={adiantamento.id}>{adiantamento.num_documento}</td>
                            <td id={adiantamento.id}>{adiantamento.fornecedor.descricao}</td>
                            <td id={adiantamento.id}>{format(new Date(adiantamento.data), 'dd/MM/yyyy', { timeZone: 'America/Sao_Paulo' })}</td>
                            <td id={adiantamento.id}>{format(new Date(adiantamento.previsao_encerramento), 'dd/MM/yyyy', { timeZone: 'America/Sao_Paulo' })}</td>
                            <td id={adiantamento.id}>{adiantamento.vlr_total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                            <td id={adiantamento.id}>{adiantamento.saldo.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                            <td id={adiantamento.id}>REJEITADO</td>
                        </tr>
                    );
                } else {
                    return (<></>);
                }
            case 4:
                return (
                    <tr className="table-secondary mouse" onClick={clickTable} id={adiantamento.id} key={adiantamento.id}>
                        <td id={adiantamento.id}>{adiantamento.empresa.descempresa}</td>
                        <td id={adiantamento.id}>{adiantamento.solicitante}</td>
                        <td id={adiantamento.id}>{adiantamento.num_documento}</td>
                        <td id={adiantamento.id}>{adiantamento.fornecedor.descricao}</td>
                        <td id={adiantamento.id}>{format(new Date(adiantamento.data), 'dd/MM/yyyy', { timeZone: 'America/Sao_Paulo' })}</td>
                        <td id={adiantamento.id}>{format(new Date(adiantamento.previsao_encerramento), 'dd/MM/yyyy', { timeZone: 'America/Sao_Paulo' })}</td>
                        <td id={adiantamento.id}>{adiantamento.vlr_total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                        <td id={adiantamento.id}>{adiantamento.saldo.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                        <td id={adiantamento.id}>PAGO</td>
                    </tr>
                );
            case 5:
                return (
                    <tr className="bg-primary mouse" onClick={clickTable} id={adiantamento.id} key={adiantamento.id}>
                        <td id={adiantamento.id}>{adiantamento.empresa.descempresa}</td>
                        <td id={adiantamento.id}>{adiantamento.solicitante}</td>
                        <td id={adiantamento.id}>{adiantamento.num_documento}</td>
                        <td id={adiantamento.id}>{adiantamento.fornecedor.descricao}</td>
                        <td id={adiantamento.id}>{format(new Date(adiantamento.data), 'dd/MM/yyyy', { timeZone: 'America/Sao_Paulo' })}</td>
                        <td id={adiantamento.id}>{format(new Date(adiantamento.previsao_encerramento), 'dd/MM/yyyy', { timeZone: 'America/Sao_Paulo' })}</td>
                        <td id={adiantamento.id}>{adiantamento.vlr_total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                        <td id={adiantamento.id}>{adiantamento.saldo.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                        <td id={adiantamento.id}>CONCLUIDO</td>
                    </tr>
                );
            case 6:
                return (
                    <tr className="bg-light mouse" onClick={clickTable} id={adiantamento.id} key={adiantamento.id}>
                        <td id={adiantamento.id}>{adiantamento.empresa.descempresa}</td>
                        <td id={adiantamento.id}>{adiantamento.solicitante}</td>
                        <td id={adiantamento.id}>{adiantamento.num_documento}</td>
                        <td id={adiantamento.id}>{adiantamento.fornecedor.descricao}</td>
                        <td id={adiantamento.id}>{format(new Date(adiantamento.data), 'dd/MM/yyyy', { timeZone: 'America/Sao_Paulo' })}</td>
                        <td id={adiantamento.id}>{format(new Date(adiantamento.previsao_encerramento), 'dd/MM/yyyy', { timeZone: 'America/Sao_Paulo' })}</td>
                        <td id={adiantamento.id}>{adiantamento.vlr_total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                        <td id={adiantamento.id}>{adiantamento.saldo.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                        <td id={adiantamento.id}>CADASTRADO</td>
                    </tr>
                );
            default:
                if (!isFinanceiro) {
                    return (
                        <tr className="table-warning mouse" onClick={clickTable} id={adiantamento.id} key={adiantamento.id}>
                            <td id={adiantamento.id}>{adiantamento.empresa.descempresa}</td>
                            <td id={adiantamento.id}>{adiantamento.solicitante}</td>
                            <td id={adiantamento.id}>{adiantamento.num_documento}</td>
                            <td id={adiantamento.id}>{adiantamento.fornecedor.descricao}</td>
                            <td id={adiantamento.id}>{format(new Date(adiantamento.data), 'dd/MM/yyyy', { timeZone: 'America/Sao_Paulo' })}</td>
                            <td id={adiantamento.id}>{format(new Date(adiantamento.previsao_encerramento), 'dd/MM/yyyy', { timeZone: 'America/Sao_Paulo' })}</td>
                            <td id={adiantamento.id}>{adiantamento.vlr_total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                            <td id={adiantamento.id}>{adiantamento.saldo.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                            <td id={adiantamento.id}>AGUARDANDO</td>
                        </tr>
                    );
                }
        }
    }

    function handleSelectEmpresa(event) {
        const emp = Object.assign({}, empresa);
        emp.selectItem = event.target.value;
        setEmpresa(emp);
    }

    function handleSelectStatus(event) {
        const cstatus = Object.assign([], status);
        cstatus.selectItem = event.target.value;
        setStatus(cstatus);
    }

    function handleFilter(page) {

        if (!buscando) {
            var filtros = '';

            setBuscando(true);

            if (page === 0) {
                filtros = filtros + '?page=' + page;
            } else {
                filtros = filtros + '?page=' + pageClicked;
            }

            var filtrauser = true;
            if (usuario?.perfis) {
                usuario.perfis.forEach((perfil) => {
                    if (perfil.id == 1 || perfil.id == 3) {
                        filtrauser = false;
                    }
                })
            }

            if (empresa.selectItem !== 0) {
                if (filtros == '') {
                    filtros = '?empresa=' + empresa.selectItem;
                } else {
                    filtros = filtros + '&empresa=' + empresa.selectItem;
                }
            }

            if (filtrauser) {
                if (filtros == '') {
                    filtros = '?usuario=' + usuario.id;
                } else {
                    filtros = filtros + '&usuario=' + usuario.id;
                }
            }
            if (status.selectItem !== 6) {
                if (filtros == '') {
                    filtros = '?status=' + status.selectItem;
                } else {
                    filtros = filtros + '&status=' + status.selectItem;
                }

            }
            if (pedido !== '') {
                if (filtros == '') {
                    filtros = '?pedido=' + pedido;
                } else {
                    filtros = filtros + '&pedido=' + pedido;
                }
            }

            if (dtIni !== '') {
                if (filtros == '') {
                    filtros = '?dtini=' + dtIni;
                } else {
                    filtros = filtros + '&dtini=' + dtIni;
                }
            }
            if (dtFin !== '') {
                if (filtros == '') {
                    filtros = '?dtfin=' + dtFin;
                } else {
                    filtros = filtros + '&dtfin=' + dtFin;
                }
            }

            if (fornecedor && fornecedor !== '') {
                console.log('entra aqui caceta')
                if (filtros == '') {
                    filtros = '?fornecedor=' + fornecedor;
                } else {
                    filtros = filtros + '&fornecedor=' + fornecedor;
                }
            }

            if (usuario.adi_setor_id && usuario.adi_setor_id !== '') {
                filtros = filtros + '&setor=' + usuario.adi_setor_id;
            }

            api.get(`/adiantamento/find${filtros}`).then(function (response) {
                if (response.data) {
                    response.data.rows.forEach((adiantamento) => {
                        var totalpgtos = 0;
                        var totalenc = 0;
                        adiantamento.saldo = 0;
                        adiantamento.vlr_total = 0;
                        adiantamento.total_enc = 0;
                        if (adiantamento.status !== 3) {
                            totalpgtos = adiantamento.total_pgto;
                            totalenc = adiantamento.total_enc;
                            adiantamento.vlr_total = totalpgtos || 0;
                            adiantamento.total_enc = totalenc || 0;
                            adiantamento.saldo = totalpgtos - totalenc;
                        }
                    });
                    var pages = {};
                    pages.currentpage = response.data.currentpage;
                    pages.nextpage = response.data.nextpage;
                    pages.prevpage = response.data.prevpage;
                    pages.lastpage = response.data.lastpage;
                    setpage(pages);
                    setAdiantamentos(response.data.rows);
                }
            }).catch(function (error) {
                // handle error
                console.log(error);
            }).then(function () {
                // always executed
                setBuscando(false);
            });
        }
    }

    useEffect(() => {
        api.get(`/usuarios/getbytoken`).then(function (response) {
            if (response.data) {
                setUsuario(response.data);
                var emp = {
                    items: [
                        { id: 0, text: "TODOS" }
                    ],
                    selectItem: 0
                }
                response.data.empresas.forEach((empresa, index) => (
                    emp.items.push({ id: empresa.id, text: empresa.descempresa })
                ))
                setEmpresa(emp);
            }
        }).catch(function (error) {
            // handle error
            console.log(error);
        }).then(function () {
            // always executed
        });
    }, [])

    function renderNovo() {

        if (usuario && usuario.perfis) {
            var canrender = false;
            usuario.perfis.map((perfil) => {

                if (perfil.descricao == 'SOLICITANTE' || perfil.descricao == 'ADMINISTRADOR') {
                    canrender = true;

                }
            })
            if (canrender) {
                return (
                    <div className="solicitacoes">
                        <input type="submit" value="NOVO LANÇAMENTO" className="btn btn-success btn-lg" onClick={onSubmit} />
                    </div>
                )
            }
        }
    }

    function handlePageClick(p) {
        if (p <= page.lastpage && p > 0) {
            setPageClicked(p);
            setFilter(true);
        }

    }

    useEffect(() => {
        if (filter == true) {
            handleFilter();
            setFilter(false);
        }
    }, [filter]);

    function renderpages() {
        return (
            <div>
                {(() => {
                    const options = [];

                    options.push(<i className="paginas" onClick={() => handlePageClick(1)}>Primeira</i>);
                    options.push(<i className="paginas" onClick={() => handlePageClick(page.prevpage)}>Anterior</i>);
                    if (page.lastpage > 20) {
                        if (page.currentpage < 10) {
                            for (let i = 1; i <= 20; i++) {
                                if (i == page.currentpage) {
                                    options.push(<i value={i} className="paginas selected" onClick={() => handlePageClick(i)}>{i}</i>);
                                } else {
                                    options.push(<i value={i} className="paginas" onClick={() => handlePageClick(i)}>{i}</i>);
                                }

                            }
                        } else {
                            if (page.currentpage + 10 < page.lastpage) {
                                for (let i = page.currentpage - 10; i <= page.currentpage + 10; i++) {
                                    if (i == page.currentpage) {
                                        options.push(<i value={i} className="paginas selected" onClick={() => handlePageClick(i)}>{i}</i>);
                                    } else {
                                        options.push(<i value={i} className="paginas" onClick={() => handlePageClick(i)}>{i}</i>);
                                    }

                                }
                            } else {
                                for (let i = page.lastpage - 20; i <= page.lastpage; i++) {
                                    if (i == page.currentpage) {
                                        options.push(<i value={i} className="paginas selected" onClick={() => handlePageClick(i)}>{i}</i>);
                                    } else {
                                        options.push(<i value={i} className="paginas" onClick={() => handlePageClick(i)}>{i}</i>);
                                    }

                                }
                            }

                        }

                    } else {
                        for (let i = 1; i <= page.lastpage; i++) {
                            if (i == page.currentpage) {
                                options.push(<i value={i} className="paginas selected" onClick={() => handlePageClick(i)}>{i}</i>);
                            } else {
                                options.push(<i value={i} className="paginas" onClick={() => handlePageClick(i)}>{i}</i>);
                            }

                        }
                    }

                    options.push(<i className="paginas" onClick={() => handlePageClick(page.nextpage)}>Próxima</i>);
                    options.push(<i className="paginas" onClick={() => handlePageClick(page.lastpage)}>Ultima</i>);
                    return options;
                })()}
            </div>
        )

    }

    function renderRow() {
        if (buscando) {
            return (
                <div className={styles.divloading}>
                    <div className={styles.loading}></div>
                </div>
            )
        } else {
            return (
                adiantamentos.map(adiantamento => {
                    return (
                        rowAdiantamento(adiantamento)
                    )
                })
            )
        }
    }

    return (
        <div className="container-lg">
            <Header title="SOLICITAÇÕES DE ADIANTAMENTO" />
            <div className="solicitacoes mb-2">
                <div className="border">
                    <div className="row col-md-12 mb-2">
                        <h4 className="col-md-12">FILTROS</h4>
                        <div className="col-md-12 d-flex">
                            <label className="col-md-1">Empresa:</label>
                            <select className="col-md-4" value={empresa.selectItem} onChange={handleSelectEmpresa}>
                                {empresa.items.map((item, index) => (
                                    <option key={item.id} value={item.id}>{item.text}</option>
                                ))}
                            </select>
                            <div className="col-md-2"></div>
                            <label className="col-md-1">Status:</label>
                            <select className="col-md-4" value={status.selectItem} onChange={handleSelectStatus}>
                                {status.items.map((item, index) => (
                                    <option key={item.id} value={item.id}>{item.text}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-2">
                            <label>Pedido/Contrato:</label>
                            <input type="text" id="num_doc" className="form-control" value={pedido} onChange={(e) => setPedido(e.target.value)}></input>
                        </div>
                        <div className="col-md-6">
                            <label>Fornecedor:</label>
                            <input type="text" id="cod_fornecedor" className="form-control" value={fornecedor} onChange={(e) => setFornecedor(e.target.value)}></input>
                        </div>
                        <div className="col-md-2">
                            <label>Data Inicial:</label>
                            <input id="date" type="date" value={dtIni} onChange={(e) => setDtIni(e.target.value)}></input>
                        </div>
                        <div className="col-md-2">
                            <label>Data Final:</label>
                            <input id="date" type="date" value={dtFin} onChange={(e) => setDtFin(e.target.value)}></input>
                        </div>
                    </div>
                    <input type="submit" value="FILTRAR" className="btn btn-warning mb-2" onClick={() => handleFilter(0)} />
                </div>
                <div className="content">
                    <table className="table table-sm solicitacoes">
                        <thead>
                            <tr>
                                <th scope="col">Empresa</th>
                                <th scope="col">Solicitante</th>
                                <th scope="col">Doc.</th>
                                <th scope="col">Fornecedor</th>
                                <th scope="col">Data</th>
                                <th scope="col">Previsão enc.</th>
                                <th scope="col">Valor</th>
                                <th scope="col">Saldo</th>
                                <th scope="col">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                renderRow()
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            {renderpages()}
            {renderNovo()}
        </div>
    )
}